<!--------------Footer first-Section Starts-->
<style>
    /* .fading-1 {
  background: 
  linear-gradient(90deg, transparent, #2F9EDD, transparent) 
    bottom /var(--d, 0) 3px no-repeat;
  transition: 0.5s;
}
.fading-1:hover {
  --d: 100%;
} */
</style>
<div class="container-fluid p-0">
    <div class="footer-area-wrapper ">
        <div class="container-fluid p-0" *ngIf="!isInternshipRoute">
            <div class=" row m-0">
                <div class=" col-lg-12 p-0">
                    <div class="footer-title p-5">
                        <div class="p-2 global_section_header thirdheading  text-white text-center ">Drive from
                            meaningful change to measurable value.</div>
                        <div class="p-2 global_section_content fourthheading text-white text-center">Get free
                            consultation and let us know your project idea
                            to turn it into an
                            amazing digital
                            product. </div>
                        <div class="global_mainbutton text-center col pt-5">

                            <a href="contact" title="contact"
                                class="global_button   text-left col  text-white white_button">
                                <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png"
                                        alt="drive button" /></div>
                                LET'S
                                DISCUSS
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--------------Footer first-Section ends-->
    <div class="footer-area section-space">
        <div class="container-fluid p-0">
            <div class="footer-widget-wrapper">
              
                <div class="row m-0">

                    <div class="col-lg-3 col-12 p-0">
                        <div class="footer-content py-5 p-3 p-md-4 p-xl-3">
                            <div class="fifthheading my-2 my-md-4 text-black">
                                <span class="-footer-subsection" aria-haspopup="true">
                                    Discover more about Maganti IT
                                </span>
                            </div>
                            <div>
                                <form [formGroup]="subscribeForm" (ngSubmit)="onSubmit()">
                                    <div class="input-section my-2 my-md-4">
                                        <label for="subscribe_email" hidden>email</label>
                                        <input aria-required="true" required="true" type="email" id="subscribe_email"
                                         placeholder="Enter your email"
                                            formControlName="subscribeEmail" name="subscribeEmail"
                                            (change)="onEmailChange()" (blur)="onEmailChange()"
                                            class="footer_input form-control form-control-md">
                                    </div>
                                    <div *ngIf="message" style="color: #FC1500;">{{ message }}</div>
                                    <p class="my-2 my-md-2">
                                        <span class="-mit-content" style="padding-top: 10px; color: black">
                                            Learn more about Maganti IT Initiatives through our industry insights, news
                                            and
                                            articles.
                                        </span>
                                    </p>
                                    <button type="submit" aria-haspopup="true" tabindex="0" role="button" id="subscribeForm" class="submitbutton"
                                        style="color : black;">Subscribe</button>
                                        <div *ngIf="loading" class="loader-container">
                                            <mat-spinner></mat-spinner>
                                            <div class="loader-wheel"></div>
                                          </div>
                                </form>
                            </div>

                           
                        </div>
                    </div>

                    <div class="col-lg-9 col-12 p-0 text-center text-lg-start ">

                       
                          <!-- Grid container -->
                          <div class="container-fluid p-4">
                           
                            <div class="row my-4">
                              <!--Grid column-->
                              <div class="col-lg-3 col-md-6 mb-4 mb-md-0" role="main">
                                <div class="d-flex align-items-center justify-content-center">
                                    <div class=" px-5 px-md-0-">
                                        <!-- <div class="footer-widget__homepage mt-5- pb-3 mb-3" style="border-bottom: 1px solid #ccc !important">
                                            <img src="https://mitresource.com/wp-content/themes/magantiWeb/assets/images/homepage/newmitlogo.png" class="footer_logo img img-responsive px-5 px-md-0 m-auto" alt="footer company logo">
                                        </div> -->
                                        <div class=" shadow-1-strong d-flex align-items-center justify-content-center mb-2 mx-auto" style=" height: 150px;border-bottom: 1px solid #ccc !important">
                                            <img  src="../../../assets/images/homepage/newmitlogo.png" height="80" alt="newmitlogo"
                                                 loading="lazy" />
                                               
                                          </div>
                                        <div class="h-25 logo-content p-0">
                                            <p>A Leader in IT and Business Consulting</p>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class=" shadow-1-strong d-flex align-items-center justify-content-center mb-2 mx-auto" style="width: 200px; height: 150px;">
                                  <img  src="../../../assets/images/homepage/newmitlogo.png" height="70" alt="newmitlogo"
                                       loading="lazy" />
                                     
                                </div>
                                <hr>
                                <p class="text-center">A Leader in IT and Business Consulting</p> -->
                               
                      
                               
                      
                                <!-- <ul class="list-unstyled d-flex flex-row justify-content-center">
                                  <li>
                                    <a class="px-2" href="https://www.facebook.com/MagantiItResources">
                                      <i class="fab fa-facebook-square"></i>
                                    </a>
                                  </li>
                                  <li>
                                    <a class=" px-2" href="https://www.instagram.com/magantiit/">
                                      <i class="fab fa-instagram"></i>
                                    </a>
                                  </li>
                                  <li>
                                    <a class=" ps-2" href="https://www.linkedin.com/company/maganti-it-resources-llc/mycompany/">
                                        <i class=" fa fa-linkedin" aria-hidden="true"></i>
                                    </a>
                                  </li>
                                  <li>
                                    <a class=" ps-2" href="https://twitter.com/mitresource">
                                        <i class=" fa fa-" aria-hidden="true"></i>
                                    </a>
                                  </li>
                                </ul> -->
                      
                              </div>
                              <!--Grid column-->
                      
                              <!--Grid column-->
                              <div class="col-lg-3 col-md-6 mb-4 mb-md-0" role="main">
                                <div class=" mb-4 categories h4 fw-bold" title="Company">Company</div>
                      
                                <ul class="list-unstyled"  role="main" style="font-size:16px">
                                  <li class="mb-2">
                                    <a  routerLink="/journey" >About Us</a>
                                  </li>
                                  <li class="mb-2">
                                    <a  routerLink="/careers" role="button" aria-haspopup="true" tabindex="0">Careers</a>
                                  </li>
                                  <li class="mb-2">
                                    <a  routerLink="/capability-statement" >Capability Statement</a>
                                  </li>
                                  <li class="mb-2">
                                    <a  routerLink="/recognition">Recognition</a>
                                  </li>
                                  <li class="mb-2">
                                    <a  routerLink="/corporate-giving" >Corporate Giving</a>
                                  </li>
                                  <!-- <li class="mb-2">
                                    <a  routerLink="/teams" >Team</a>
                                  </li> -->
                                
                                </ul>
                              </div>
                              <!--Grid column-->
                              <!--Grid column-->
                              <div class="col-lg-3 col-md-6 mb-4 mb-md-0" role="main">
                                <div class="h4 fw-bold mb-4 categories" title="Information">Information</div>
                      
                                <ul class="list-unstyled"  role="main" style="font-size:16px">
                                  <li class="mb-2">
                                    <a href="application-services" >Application Development</a>
                                  </li>
                                  <li class="mb-2">
                                    <a href="mobileservices" >Mobile Development</a>
                                  </li>
                                  <li class="mb-2">
                                    <a href="cloudservices" >Cloud Services</a>
                                  </li>
                                  <li class="mb-2">
                                    <a href="retail" >Retail</a>
                                  </li>
                                  <li class="mb-2">
                                    <a href="finance" >Finance</a>
                                  </li>
                                  <li class="mb-2">
                                    <a href="manufacturing">Manufacturing</a>
                                  </li>
                                </ul>
                              </div>
                              <!--Grid column-->
                      
                              <!--Grid column-->
                              <div class="col-lg-3 col-md-6 mb-4 mb-md-0" role="main">
                                <div class="h4 fw-bold  mb-4 categories" title="Reach us">Reach Us</div>
                      
                                <ul class="list-unstyled address-list"  role="main" style="font-size:16px">
                                    <!-- <li>
                                        <a href="privacy" >Privacy-Policy</a>
                                      </li> -->
                                  <li>
                                    <p>21 State Street,
                                        Waterbury, CT - 06702</p>
                                  </li>
                                  
                                  <li>
                                    <p (click)="scrollToSection('main-wrapper')" class="footerEmail" style="display: flex;align-items: baseline;"><i class="fas fa-envelope pe-2 mb-0 ms-0" role="presentation"></i><span style="word-break: break-word;">info&#64;mitresource.com</span></p>
 
 
                                  </li>
                                  <li>
                                    <p (click)="scrollToSection('main-wrapper')"><i class="fas fa-phone pe-2 ms-0" role="presentation"></i>  1-855-217-4637</p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                      </div>
            </div>
            <footer role="contentinfo" aria-label="Footer with copyright information" 
             class="text-center text-lg-start" style="background-color: grey;">
                <div class="text-center text-white p-3" style="background-color: rgba(0, 0, 0, 0.2);">
                    ©{{ currentYear }} Maganti IT Resources LLC. All
                    Rights Reserved.
                </div>
            </footer>
        </div>
    </div>
</div>

<style>/* Style for the list container */
    ul.address-list {
        font-size: 1rem; /* Base font size */
    }
    
    /* Style each list item with equal spacing */
    ul.address-list li {
        margin-bottom: 20px; /* Adds space between each list item */
    }
    
    /* Style for icons to make them responsive */
    ul.address-list i {
        font-size: 1.2em; /* Scales the icon size */
        vertical-align: middle; /* Aligns icons with text */
    }
    
    /* Responsive font-size adjustments */
    @media (max-width: 768px) {
        ul.address-list {
            font-size: 0.9rem; /* Smaller font size on mobile */
        }
        
        ul.address-list i {
            font-size: 1em; /* Adjusts icon size on smaller screens */
        }
    }
    </style>
<div class="mobile-menu-overlay" #mobileMenuOverlay>
    <div class="mobile-menu-overlay__inner">
        <div class="mobile-menu-overlay__header">
            <div class="container-fluid">
                <div class="row align-items-center">
                    <div class="col-md-6 col-8">
                        <div class="homepage">
                            <a href={{webUrl}}>
                                <img src="../../../assets/images/homepage/newmitlogo.png" class="img-fluid"
                                    alt="newlogo mit" />
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 col-4">
                        <div class="mobile-menu-content text-end">
                            <span class="mobile-navigation-close-icon" id="mobile-menu-close-trigger"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mobile-menu-overlay__body">
            <nav class="offcanvas-navigation offcanvas-navigation--onepage">
                <ul>

                    <li class="has-children active">

                        <a href="#" role="button" aria-haspopup="true" tabindex="0"
                        >Services</a>
                        <ul class="sub-menu">
                            <li class="has-children">

                            <li class="has-children">
                                <a href="#">Technology Development</a>
                                <ul class="sub-menu">

                                    <li class="fading-1"> <a href="application-services"> <i class="fa fa-desktop"
                                                aria-hidden="true"></i>
                                            <span>Application Development</span></a> </li>
                                    <li> <a href="mobileservices"><span> <i
                                                    class="fa fa-mobile MobileApplicationDevelopment"
                                                    aria-hidden="true"> </i> Mobile Application Development </span> </a>
                                    </li>
                                    <li> <a href="cloudservices"><span> <i class="fa fa-cloud" aria-hidden="true"></i>
                                                Cloud Computing Services </span></a> </li>
                                    <li> <a href="database-services"> <i class="fa fa-database" aria-hidden="true"> </i>
                                            <span>Database Services </span></a> </li>
                                  
                                    <li> <a href="operation-maintanance"> <i class="fa fa-wrench" aria-hidden="true">
                                            </i> <span>Operation and Maintainence </span> </a> </li>

                                    <li> <a href="artificial-intelligence" style="margin-left:-20px"> <i
                                                class='fas fa-brain' aria-hidden="true"
                                                style="font-size:13px!important"></i>
                                            <span>AI / ML Services</span> </a> </li>


                                </ul>
                            </li>
                            <li class="has-children">
                                <a href="technology-staffing">Technology Staffing</a>
                               
                            </li>
                            <li class="has-children">
                                <a href="technology-training">Technology Training</a>
                               
                            </li>
                            <li class="has-children">
                                <a href="https://mitdigital360.com/" target=”_blank>Digital Marketing</a>
                                
                            </li>
                        </ul>
                    </li>
                    <li class="has-children">
                        <a href="#element" role="button" aria-haspopup="true" tabindex="0"
                        >Industries</a>
                        <ul class="sub-menu">
                            <li class="has-children">

                            <li class="has-children">
                                <a href="manufacturing">Manufacturing</a>
                               
                            </li>
                            <li class="has-children">
                                <a href="finance">Finance</a>
                               
                            </li>
                            <li class="has-children">
                                <a href="entertainment">Entertainment</a>
                               
                            </li>
                            <li class="has-children">
                                <a href="retail">Retail</a>
                                
                            </li>
                        </ul>
                    </li>
                    <li class="has-children">
                        <a href="#" role="button"aria-haspopup="true"tabindex="0"
                        >About</a>
                        <ul class="sub-menu">
                            <li class="has-children">

                            <li class="has-children">
                                <a href="journey">Journey</a>
                               
                            </li>
                            <!-- <li class="has-children">
                                <a href="teams">Team</a>
                               
                            </li> -->
                            <li class="has-children">
                                <a href="recognition">Recognition</a>
                               
                            </li>
                            <li class="has-children">
                                <a href="corporate-giving">Corporate Giving</a>
                              
                            </li>
                        </ul>
                    </li>
                    <li class="has-children">
                        <a href="#" role="button" aria-haspopup="true" tabindex="0"
                        >Insight</a>
                        <ul class="sub-menu">
                            <li class="has-children">


                            <li class="has-children">
                                <a href="case-studies">Case Studies</a>
                              
                            </li>
                            <li class="has-children">
                                <a href="blogs">Blogs</a>
                                
                            </li>


                        </ul>
                    </li>
                    <li class="has-children">
                        <a href="careers"role="button"aria-haspopup="true"tabindex="0"
                        >Careers</a>
                        <ul class="sub-menu">
                            <li class="has-children">


                            <li class="has-children">
                                <a href="careers">Explore Jobs</a>
                                
                            </li>
                            <li class="has-children">
                                <a href="internship">Internship</a>
                               
                            </li>


                        </ul>
                    </li>

                    <li>
                        <a href="mitevents"><span>Meetups</span></a>
                    </li>
                    <li>
                        <a href="contact">Contact</a>
                    </li>

                 



                </ul>
            </nav>
            <div style="float: right; ">
                <ul class="list ht-social-networks">
                    <li class="item">
                        <a role="button"aria-haspopup="true"tabindex="0" href="https://www.linkedin.com/company/maganti-it-resources-llc/mycompany/" target="_blank"
                            aria-label="Linkedin" class="social-link hint--bounce hint--bottom hint--primary">
                            <i class=" text-white fa fa-linkedin" aria-hidden="true"></i>
                        </a>
                    </li>
                    <li class="item">
                        <a href="https://twitter.com/mitresource" target="_blank" aria-label="Twitter"
                            class="social-link hint--bounce hint--bottom hint--primary">
                            <img src="../../../assets/images/banners/twitterlogo.png" alt="twitter latest" width='42px'
                                height="18px" style="filter: brightness(0) invert(1);" />
                        </a>
                    </li>
                    <li class="item">
                        <a href="https://www.instagram.com/magantiit/" target="_blank" aria-label="instagram"
                            class="social-link hint--bounce hint--bottom hint--primary">
                            <i class="text-white fa fa-instagram" aria-hidden="true"></i>
                        </a>
                    </li>
                  
                </ul>
            </div>
        </div>
    </div>

</div>
<!--====================  End of mobile menu overlay  ====================-->
<!-- <====================  mobile menu overlay ====================-->


<!--====================  search overlay ====================-->
<div class="search-overlay" id="search-overlay">
    <div class="search-overlay__header">
        <div class="container-fluid">
            <div class="row align-items-center">
                <div class="col-md-6 ms-auto col-4">
                    <!-- search content -->
                    <div class="search-content text-end">
                        <span class="mobile-navigation-close-icon" id="search-close-trigger"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="search-overlay__inner">
        <div class="search-overlay__body">
            <div class="search-overlay__form">
                <form action="#">
                    <label>Search: <input type="text" placeholder="Search"></label>
                </form>
            </div>
        </div>
    </div>
</div>
<!--====================  End of search overlay  ====================-->
